(function () {
    'use strict';

    var ID = 'jw-player',
        isDebug = true,
        elements = [];

    // FIXME: remove section below once we only output logs in dev env
    var log = function () {
        if (isDebug) console.log.apply(null, Array.prototype.slice.call(arguments));
    };

    /*
     *      JWplayer Class
     */
    var JWplayer = function ($player) {
        this.$html = $player.addClass('initialized');
        return this.init();
    };

    JWplayer.prototype = {
        id: '',
        $html: {},
        key: '',
        apiHost: '',
        newsID: 0,
        isAutoStart: false,
        player: {},
        $player: {},
        $playerWrapper: {},
        $window: {},
        $duration: {},
        $playButton: {},
        playlist: [],
        $playlist: {},
        $leftArrow: {},
        leftArrowShown: false,
        $rightArrow: {},
        rightArrowShown: false,
        $videoTemplate: {},
        activeVideo: {},
        previousActiveVideo: {},
        hoverTimeout: {},
        delayInit: true,
        isPlayerLoaded: false,
        isFeedLoaded: false,
        isConfigLoaded: false,
        isPrebidLoaded: false,
        isWindows: false,
        isHover: false,
        isUserSelection: false,
        isPlayingSameVideo: false,
        isFirstVideo: true,
        firstVideoIndex: 0,
        isMuted: false,
        playedVideos: {},
        stats: {},
        vastTags: {},
        gtags: {},
        gtag: '',
        xandrIDs: {},
        xandrID: '',
        gpsIDs: {},
        gpsID: '',
        adSchedule: [],
        currentAdSchedule: [],
        usePrebid: false,
        prebidAdUnit: {},
        prebidBids: {},
        forceNextAd: true,

        init: function () {
            log(ID + '::init');
            this.id = ID + elements.length;
            this.key = this.$html.attr('data-key');
            this.apiHost = this.$html.attr('data-api-host');
            this.newsID = this.$html.attr('data-news-id') || 0;
            this.isAutoStart = this.$html.attr('data-autostart') === 'true';
            this.delayInit = this.$html.attr('data-delay-init') !== 'false';
            this.player = null;
            this.$player = this.$html.find('.player');
            this.$playerWrapper = this.$html.find('.player-wrapper');
            this.$window = $(window);
            this.$duration = this.$playerWrapper.find('.duration');
            this.$playButton = this.$playerWrapper.find('.play-button');
            this.playButtonTimeout = null;
            this.playlist = [];
            this.$playlist = this.$html.find('ul.playlist');
            this.$leftArrow = this.$html.find('.arrow.left').hide();
            this.leftArrowShown = false;
            this.$rightArrow = this.$html.find('.arrow.right').hide();
            this.rightArrowShown = false;
            this.$videoTemplate = this.$html.find('li.template');
            this.activeVideo = {};
            this.previousActiveVideo = {};
            this.hoverTimeout = null;
            this.isPlayerLoaded = false;
            this.isFeedLoaded = false;
            this.isConfigLoaded = false;
            this.isPrebidLoaded = false;
            this.isWindows = navigator.platform.indexOf('Win') > -1;
            this.isHover = false;
            this.isUserSelection = false;
            this.isPlayingSameVideo = false;
            this.isFirstVideo = true;
            this.firstVideoIndex = 0;
            this.isMuted = localStorage.getItem(ID + '-muted');
            this.isMuted = this.isMuted === null ? this.isAutoStart : this.isMuted === 'true';

            this.playedVideos = localStorage.getItem(ID + '-viewed');
            this.playedVideos = this.playedVideos ? JSON.parse(this.playedVideos) : {};

            this.vastTags = {};
            this.gtags = {};
            this.gtag = '';
            this.xandrIDs = {};
            this.xandrID = '';
            this.gpsIDs = {};
            this.gpsID = '';
            this.adSchedule = [];
            this.currentAdSchedule = [];
            this.usePrebid = false;
            this.prebidAdUnit = {};
            this.prebidBids = {};
            this.forceNextAd = true; // Always show an ad on the first video

            this.stats = {
                video: {
                    id: 'video',
                    isActive: false,
                    count: 0,
                    duration: 0,
                    lastTick: 0,
                    lastPush: 0,
                    pushSteps: [
                        [1, 1], // after 1 second - every second
                        [10, 5], // after 10 seconds - every 5 seconds
                        [20, 10], // after 20 seconds - every 10 seconds
                        [60, 20], // after 1 minute - every 20 seconds
                        [60 * 3, 60], // after 3 minutes - every 60 seconds
                    ],
                },
                ad: {
                    id: 'ad',
                    isActive: false,
                    count: 0,
                    requestCount: 0,
                    duration: 0,
                    lastTick: 0,
                    lastPush: 0,
                    pushSteps: [
                        [1, 1], // after 1 seconds - every second
                        [5, 5], // after 5 seconds - every 5 seconds
                        [30, 20], // after 30 seconds - every 30 seconds
                        [60 * 3, 60], // after 3 minutes - every 60 seconds
                    ],
                },
                buffer: {
                    id: 'buffer',
                    isActive: false,
                    count: 0,
                    duration: 0,
                    lastTick: 0,
                    lastPush: 0,
                    pushSteps: [
                        [5, 1], // after 1 second - every second
                        [5, 5], // after 5 second - every 5 seconds
                    ],
                },
            };

            if (this.isWindows) {
                this.$html.addClass('for-windows');
            }

            this.loadVideofeedConfig();
            this.loadVideofeed();
            if (this.delayInit) {
                this.$window.on('scroll', $.proxy(this.onWindowScrolled, this));
            } else {
                this.loadPlayer();
            }

            return this;
        },

        onWindowScrolled: function () {
            this.$window.off('scroll', this.onWindowScrolled);
            this.loadPlayer();
        },

        loadPlayer: function () {
            log(ID + '::loadPlayer');

            $.getScript('//ssl.p.jwpcdn.com/player/v/8.27.1/jwplayer.js')
                .done($.proxy(this.onPlayerLoaded, this))
                .fail($.proxy(this.onLoadingFailure, this));
        },

        loadPrebid: function () {
            log(ID + '::loadPrebid');

            window.pbndm = window.pbndm || {};
            window.pbndm.que = window.pbndm.que || [];

            $.getScript('//ads.nextday.media/prebid/jw-video/7.43.0.min.js')
                .done($.proxy(this.onPrebidLoaded, this))
                .fail($.proxy(this.onLoadingFailure, this));
        },

        loadVideofeed: function () {
            log(ID + '::loadVideofeed');
            $.ajax({
                type: 'GET',
                url:
                    this.apiHost +
                    '/domain/' +
                    (window.platform === 'sp' ? 1 : window.domain_id) +
                    '/videofeed',
                data: {
                    status: 'active',
                    orderBy: 'position',
                    scope: 'public',
                    cache: /cache=false/.test(window.location.search) ? 'false' : null,
                    newsID: this.newsID,
                },
            })
                .complete($.proxy(this.onVideofeedLoaded, this))
                .fail($.proxy(this.onLoadingFailure, this));
        },

        loadVideofeedConfig: function () {
            log(ID + '::loadVideofeedConfig');
            $.ajax({
                type: 'GET',
                url: this.apiHost + '/domain/' + window.domain_id + '/videofeed-config',
                data: {
                    cache: /cache=false/.test(window.location.search) ? 'false' : null,
                },
            })
                .complete($.proxy(this.onVideofeedConfigLoaded, this))
                .fail($.proxy(this.onLoadingFailure, this));
        },

        onPlayerLoaded: function () {
            log(ID + '::playerLoaded');
            jwplayer.key = this.key;
            this.isPlayerLoaded = true;
            this.checkIfReady();
        },

        onPrebidLoaded: function () {
            log(ID + '::onPrebidLoaded');

            this.prebidBids = {
                xandr: {
                    bidder: 'xandr',
                    params: {
                        placementId: this.xandrID,
                    },
                },
                GroupM_gps: {
                    bidder: 'GroupM_gps',
                    params: {
                        placementId: this.gpsID,
                    },
                },
            };

            this.prebidAdUnit = {
                code: 'video1',
                mediaTypes: {
                    video: {
                        context: 'instream',
                        playerSize: [640, 480],
                        mimes: ['video/mp4'],
                        protocols: [1, 2, 3, 4, 5, 6, 7, 8],
                        playbackmethod: [2],
                        skip: 1,
                    },
                },
                bids: this.getBids(),
            };

            window.pbndm.que.push(
                function () {
                    window.pbndm.addAdUnits(this.prebidAdUnit);
                    window.pbndm.setConfig({
                        debug: isDebug,
                        cache: { url: 'https://prebid.adnxs.com/pbc/v1/cache' },
                    });
                    window.pbndm.bidderSettings = {
                        standard: { storageAllowed: true },
                    };
                    window.pbndm.aliasBidder('appnexus', 'xandr');
                    window.pbndm.aliasBidder('appnexus', 'GroupM_gps');
                }.bind(this)
            );

            this.isPrebidLoaded = true;
            this.checkIfReady();
        },

        getBids: function () {
            var bids = [];
            if (this.xandrID) bids.push(this.prebidBids.xandr);
            if (this.gpsID) bids.push(this.prebidBids.GroupM_gps);
            return bids;
        },

        onVideofeedLoaded: function (jqXHR, status) {
            log(ID + '::onVideofeedLoaded');
            if (status !== 'success') {
                return this.onLoadingFailure();
            }
            var response = JSON.parse(jqXHR.responseText);
            if (!response || !response.data) {
                return this.onLoadingFailure();
            }

            this.playlist = response.data.map(this.formatVideoFeedItem.bind(this));

            if (this.playlist.length === 0) {
                return this.onLoadingFailure();
            }

            this.isFeedLoaded = true;
            this.checkIfReady();
        },

        formatVideoFeedItem: function (video, index) {
            var playlistItem = $.extend({}, video, {
                title: video.domainTitle || video.title,
                file: video.url,
                image: video.preview || video.thumbnail,
                duration: parseInt(video.duration, 10),
                formattedDuration: this.formatDuration(video.duration),
            });

            if (
                video.experimentTitle &&
                ((window.isEven && video.id % 2 !== 0) || (!window.isEven && video.id % 2 === 0))
            ) {
                playlistItem.experimentShown = true;
                playlistItem.title = video.experimentTitle;
            }

            playlistItem.gaItemDetails = {
                item_id: 'videofeed_' + video.id,
                item_name: playlistItem.title,
                affiliation: playlistItem.vendor,
                index: index,
                item_brand: playlistItem.vendor,
                item_category: playlistItem.vendor,
                item_list_id: 'videofeed_playlist',
                item_list_name: 'Videofeed Playlist',
            };

            return playlistItem;
        },

        onVideofeedConfigLoaded: function (jqXHR, status) {
            log(ID + '::onVideofeedConfigLoaded');
            if (status !== 'success') {
                return this.onLoadingFailure();
            }
            var response = JSON.parse(jqXHR.responseText);
            if (!response) {
                return this.onLoadingFailure();
            }

            this.vastTags = response.vastTags || {};
            this.gtags = response.gtags || {};
            this.xandrIDs = response.xandrIDs || {};
            this.gpsIDs = response.gpsIDs || {};
            this.adSchedule = response.adSchedule || [];

            this.gtag = this.gtags ? this.gtags.default || '' : '';
            this.xandrID = this.xandrIDs ? this.xandrIDs.default || '' : '';
            this.gpsID = this.gpsID ? this.gpsID.default || '' : '';

            if (this.gtag || this.xandrID || this.gpsID) {
                this.usePrebid = true;
                this.loadPrebid();
            } else {
                this.usePrebid = false;
                this.isPrebidLoaded = true;
            }

            this.isConfigLoaded = true;
            this.checkIfReady();
        },

        onLoadingFailure: function () {
            log(ID + '::onLoadingFailure');
            this.$html.remove();
        },

        checkIfReady: function () {
            log(ID + '::checkIfReady');
            if (
                !this.isFeedLoaded ||
                !this.isConfigLoaded ||
                !this.isPlayerLoaded ||
                !this.isPrebidLoaded ||
                !this.playlist.length
            ) {
                return;
            }

            this.initPlayer();
            this.initPlaylist();
            this.initEventHandlers();
            this.$html.addClass('ready');
        },

        initPlayer: function () {
            log(ID + '::initPlayer');
            this.$player.prop('id', this.id);
            this.player = jwplayer(this.id);
            this.player.setup({
                playlist: this.playlist,
                autostart: this.isAutoStart ? 'viewable' : false,
                mute: this.isMuted || this.isAutoStart,
                preload: 'auto',
                width: '100%',
                aspectratio: '16:9',
                logo: null,
                nextUpDisplay: false,
                skin: {
                    name: 'vp',
                },
                autoPause: {
                    viewability: false,
                    pauseAds: false,
                },
                advertising: this.usePrebid
                    ? {
                          client: 'googima',
                          vpaidcontrols: true,
                          endstate: 'suspended',
                          outstream: false,
                          rules: {
                              startOnSeek: 'pre',
                              timeBetweenAds: 0,
                          },
                      }
                    : {
                          client: 'vast',
                          rules: {
                              frequency: 1,
                              startOn: 1,
                              deferAds: {},
                          },
                          vpaidcontrols: true,
                      },
                related: {
                    displayMode: 'none',
                },
                ga: {},
                abouttext: 'VoetbalPrimeur',
                aboutlink: window.location.origin,
                intl: {
                    nl_NL: {
                        advertising: {
                            admessage: 'Deze advertentie duurt nog xx seconden.',
                            cuetext: 'Advertentie',
                            skipmessage: 'Overslaan in xx',
                        },
                    },
                },
            });
        },

        initPlaylist: function () {
            log(ID + '::initPlaylist');

            this.$videoTemplate.removeClass('template').detach();

            var len = this.playlist.length,
                mainVideoIndex = null,
                $playlist = $('<div/>');

            while (len--) {
                var video = this.playlist[len];
                var $html = this.$videoTemplate.clone();
                $html.attr('data-id', video.id);
                $html.find('.title').text(video.title);
                if (video.duration) {
                    $html.find('.duration').removeClass('hidden').text(video.formattedDuration);
                }
                $html.on('click', this.onVideoClicked.bind(this, video.id));
                video.$html = $html;
                video.$preview = $html.find('.preview');
                video.$title = $html.find('.title');
                if (this.playedVideos[video.id]) {
                    video.$html.addClass('seen');
                } else {
                    this.firstVideoIndex = len;
                }
                if (video.isMain) {
                    mainVideoIndex = len;
                }
                $playlist.prepend(video.$html);
            }
            this.$playlist.append($playlist.children());

            // Set mainVideoIndex if video is used as main
            if (mainVideoIndex !== null) {
                this.firstVideoIndex = mainVideoIndex;
            }

            if (typeof gtag === 'function') {
                gtag('event', 'view_item_list', {
                    items: this.playlist.map(function (video) {
                        return video.gaItemDetails;
                    }),
                });
            }

            this.$playlist.on('scroll', this.onPlaylistScroll.bind(this));
            this.onPlaylistScroll();
            log(ID + '::initPlaylist', this.playlist);
        },

        formatDuration: function (seconds) {
            var showMinutes = Math.floor(seconds / 60);
            var showSeconds = seconds - showMinutes * 60;
            if (showMinutes < 10) {
                showMinutes = '0' + showMinutes;
            }
            if (showSeconds < 10) {
                showSeconds = '0' + showSeconds;
            }
            return showMinutes + ':' + showSeconds;
        },

        initEventHandlers: function () {
            this.player.on('playlistItem', this.onVideoActivated.bind(this));
            this.player.on('error', this.onPlayerError.bind(this));
            this.player.on('play', this.onPlay.bind(this));
            this.player.on('pause', this.onPause.bind(this));
            this.player.on('mute', this.onMute.bind(this));
            this.player.on('buffer', this.onBuffer.bind(this));
            this.player.on('beforePlay', this.onBeforePlay.bind(this));
            this.player.on('adPlay', this.onAdPlay.bind(this));
            this.player.on('adPause', this.onAdPause.bind(this));
            this.player.on('adRequest', this.onAdRequest.bind(this));
            this.player.on('adImpression', this.onAdImpression.bind(this));
            this.$playButton.on('click', this.onPlayButtonClicked.bind(this));
            this.$leftArrow.on('click', this.onArrowClicked.bind(this, true));
            this.$rightArrow.on('click', this.onArrowClicked.bind(this, false));
            this.$playerWrapper.on('mouseenter touchstart', this.onMouseEnter.bind(this));
            this.$playerWrapper.on('mouseleave', this.onMouseLeave.bind(this));
            $('body').on('touchstart', this.onMouseLeave.bind(this));
            setInterval(this.onCalculateStats.bind(this), 250);
        },

        onPlayerError: function (e) {
            log(ID + '::onPlayerError', e);
            this.onGoogleAnalyticsEvent('Error', this.activeVideo.url, e.code);
        },

        onMouseEnter: function (e) {
            log(ID + '::onMouseEnter', e);
            this.$playerWrapper.addClass('on-hover');

            if (this.hoverTimeout) {
                clearTimeout(this.hoverTimeout);
            } else {
                this.$playerWrapper.on('mousemove', this.onMouseEnter.bind(this));
            }

            var delay = e && e.type == 'touchstart' ? 1000 : 2000;
            this.hoverTimeout = setTimeout(this.onMouseLeave.bind(this), delay);
        },

        onMouseLeave: function (e) {
            if (e && e.type == 'touchstart' && this.$html.find(e.target).length) return;

            log(ID + '::onMouseLeave', e);
            this.$playerWrapper.removeClass('on-hover');
            if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
            this.$playerWrapper.off('mousemove');
        },

        onPlaylistScroll: function () {
            var scrollLeft = this.$playlist.scrollLeft(),
                totalWidth = +this.$playlist.prop('scrollWidth') - 15,
                width = this.$playlist.width();

            log(ID + '::onPlaylistScroll', scrollLeft, totalWidth, width);

            if (scrollLeft > 3 && !this.leftArrowShown) {
                this.leftArrowShown = true;
                this.$leftArrow.show();
            } else if (scrollLeft < 3 && this.leftArrowShown) {
                this.leftArrowShown = false;
                this.$leftArrow.hide();
            }

            if (scrollLeft + width < totalWidth && !this.rightArrowShown) {
                this.rightArrowShown = true;
                this.$rightArrow.show();
            } else if (scrollLeft + width > totalWidth && this.rightArrowShown) {
                this.rightArrowShown = false;
                this.$rightArrow.hide();
            }

            // Lazy load previews
            var len = this.playlist.length,
                itemWidth = this.playlist ? this.playlist[0].$html.outerWidth(true) : 0,
                wasVisible = false;

            for (var i = 0; i < len; i++) {
                var video = this.playlist[i],
                    isVisible =
                        scrollLeft + (width + itemWidth * 2) >= itemWidth * i &&
                        scrollLeft - width - itemWidth * 2 <= itemWidth * i;

                if (wasVisible && !isVisible) {
                    break;
                }

                if (isVisible && !video.isPreviewInitialized) {
                    video.isPreviewInitialized = true;
                    video.$preview.find('.image-thumb').attr('src', video.thumbnail || video.preview);
                    video.$title.addClass('cutoff-text');
                    EventHandler.trigger('refresh', video.$html);
                }

                wasVisible = isVisible;
            }
        },

        onArrowClicked: function (isLeft) {
            log(ID + '::onArrowClicked');
            var distance = this.$playlist.find('li').first().outerWidth() * 2;
            var scrollLeft = {
                scrollLeft: (isLeft ? '-=' : '+=') + distance,
            };
            this.$playlist.animate(scrollLeft, 250);
        },

        onVideoClicked: function (id) {
            log(ID + '::onVideoClicked', id);
            var len = this.playlist.length;
            this.isUserSelection = true;
            while (len--) {
                var video = this.playlist[len];
                if (video.id === id) {
                    if (this.activeVideo === video) {
                        this.onPlayButtonClicked();
                    } else {
                        this.player.playlistItem(len);
                    }
                    return;
                }
            }
        },

        moveToActive: function () {
            log(ID + '::moveToActive');
            var activeVideo = this.activeVideo.$html;
            var position = activeVideo.outerWidth(true) * (activeVideo.index() + 0.85);
            var scrollLeft = {
                scrollLeft: position,
            };
            this.$playlist.animate(scrollLeft, 250);
        },

        onVideoActivated: function (item) {
            log(ID + '::onVideoActivated', item);
            var video = this.playlist[item.index];
            if (video == this.activeVideo) return;

            //  When the first video is activated, check if another video should be the first one instead
            if (this.isFirstVideo && this.firstVideoIndex) {
                log(ID + '::onVideoActivated activate video ' + this.firstVideoIndex + ' instead');
                this.player.playlistItem(this.firstVideoIndex);
                this.player.stop();
                this.isFirstVideo = false;
                return true;
            }

            this.$playlist.find('.active').removeClass('active').removeClass('playing');
            this.activeVideo = video;
            this.activeVideo.$html.addClass('active');
            this.isFirstVideo = false;
            this.isUserSelection = false;

            // Set current duration
            this.$duration.html(video.formattedDuration);
            video.$html.addClass('active');
            this.moveToActive();

            if (typeof gtag === 'function') {
                gtag('event', 'select_content', {
                    content_type: 'videofeed',
                    item_id: this.activeVideo.gaItemDetails.item_id,
                });
            }
        },

        onBeforePlay: function () {
            log(ID + '::onBeforePlay', {
                activeVideo: this.activeVideo,
                previousActiveVideo: this.previousActiveVideo,
            });

            this.isPlayingSameVideo = this.previousActiveVideo.id === this.activeVideo.id;
            this.onCheckAdSchedule();
        },

        onCheckAdSchedule: function () {
            log(ID + '::onCheckAdSchedule', {
                forceNextAd: this.forceNextAd,
                activeVideo: this.activeVideo,
                currentAdSchedule: this.currentAdSchedule,
                vastTags: this.vastTags,
                xandrIDs: this.xandrIDs,
                gtags: this.gtags,
                gpsIDs: this.gpsIDs,
            });

            // If ads are turned off due to ?ads=false
            if (/ads=false/.test(window.location.search)) {
                log(ID + '::onCheckAdSchedule - skip ad due to `?ads=false`');
                return;
            }

            if (this.isPlayingSameVideo) {
                log(ID + '::onCheckAdSchedule - skip ad due to playing the same video again');
                return;
            }

            if (this.usePrebid) {
                this.xandrID = this.xandrIDs[this.activeVideo.vendor] || this.xandrIDs['default'];
                this.gpsID = this.gpsIDs[this.activeVideo.vendor] || this.gpsIDs['default'];
                if (!this.xandrID && !this.gpsID) {
                    log(ID + '::onCheckAdSchedule - no xandrID or gpsID found for this vendor');
                    return;
                }

                this.prebidBids.xandr.params.placementId = this.xandrID;
                this.prebidBids.GroupM_gps.params.placementId = this.gpsID;
                this.prebidAdUnit.bids = this.getBids();
                this.gtag = this.gtags[this.activeVideo.vendor] || this.gtags['default'];
                if (!this.gtag) {
                    log(ID + '::onCheckAdSchedule - no gtag found for this vendor');
                    return;
                }
            } else {
                if (!this.vastTags) {
                    log(ID + '::onCheckAdSchedule - no vastTags setup for this domain');
                    return;
                }

                var vastTag = this.vastTags[this.activeVideo.vendor] || this.vastTags['default'];
                if (!vastTag) {
                    log(ID + '::onCheckAdSchedule - no vastTag found for this vendor');
                    return;
                }
            }

            // Refill the current ad schedule
            if (!this.currentAdSchedule.length) {
                this.currentAdSchedule = this.adSchedule.slice();
                log(ID + '::onCheckAdSchedule - restart ad schedule', {
                    currentAdSchedule: this.currentAdSchedule,
                });
            }

            // If the next ad step is false, skip it
            if (!this.forceNextAd && !this.currentAdSchedule[0]) {
                log(ID + '::onCheckAdSchedule - skip ad since next up in schedule is `false`');
                this.currentAdSchedule.shift();
                return;
            }

            // If the video is shorter than 30 second, wait for the next video
            if (!this.forceNextAd && this.activeVideo.duration && this.activeVideo.duration < 30) {
                log(ID + '::onCheckAdSchedule - skip ad since video duration is less than 30 seconds');
                return;
            }

            // Otherwise, trigger the ad. If the ad is being shown, we'll remove it from the schedule in onAdImpression()
            log(ID + '::onCheckAdSchedule - trigger ad', vastTag);
            if (this.usePrebid) {
                window.pbndm.requestBids({ bidsBackHandler: this.onBiddingComplete.bind(this) });
            } else {
                this.player.playAd(vastTag);
            }

            // If the ad slot is not filled, make sure the next video we show an ad.
            this.forceNextAd = true;
        },

        onBiddingComplete: function () {
            log(ID + '::onBiddingComplete', {
                adUnit: this.prebidAdUnit,
                gtag: this.gtag,
            });

            var videoUrl = window.pbndm.adServers.dfp.buildVideoUrl({
                adUnit: this.prebidAdUnit,
                params: { iu: this.gtag, output: 'vast' },
            });

            this.player.playAd(videoUrl);
        },

        onVideoSeen: function (video) {
            log(ID + '::onVideoSeen', video);
            this.playedVideos[video.id] = true;
            localStorage.setItem(ID + '-viewed', JSON.stringify(this.playedVideos));
            video.$html.addClass('seen');
        },

        onBuffer: function (e) {
            log(ID + '::onBuffer', e);
            if (!this.stats.buffer.isActive) {
                this.onStartStat(this.stats.buffer);
            }
        },

        onPlay: function () {
            log(ID + '::onPlay');

            this.switchToPlayStatus(true);
            this.onStartStat(this.stats.video);

            if (this.previousActiveVideo.id !== this.activeVideo.id) {
                this.previousActiveVideo = this.activeVideo;
                var pushExperiment = !this.playedVideos[this.activeVideo.id];
                this.onVideoSeen(this.activeVideo);
                this.stats.video.count++;
                this.onGoogleAnalyticsEvent('Video Count', 'Total', this.stats.video.count);

                // Add to onPlay because this is the only event that is triggered after the user starts the first video in the player by clicking on the video.
                if (this.activeVideo.experimentID && pushExperiment) {
                    $.ajax({
                        type: 'POST',
                        url: '/requests/experiment.php',
                        data: {
                            domain_id: window.domain_id,
                            experiment_id: this.activeVideo.experimentID,
                            experiment_shown: this.activeVideo.experimentShown ? true : false,
                        },
                    });
                }

                if (typeof gtag === 'function') {
                    gtag('event', 'view_item', {
                        items: [$.extend({}, this.activeVideo.gaItemDetails)],
                    });
                }
            }
        },

        onAdPlay: function (e) {
            log(ID + '::onAdPlay', e);
            this.switchToPlayStatus(false);
            this.onStartStat(this.stats.ad);
        },

        onMute: function (e) {
            log(ID + '::onMute', e);
            this.isMuted = e.mute;
            localStorage.setItem(ID + '-muted', this.isMuted);
        },

        switchToPlayStatus: function (alsoInPlaylist) {
            log(ID + '::switchToPlayStatus');
            this.$playerWrapper.addClass('playing');
            if (alsoInPlaylist) {
                this.activeVideo.$html.addClass('playing');
            }
            if (this.isHover) {
                this.$playerWrapper.addClass('prevent-hover');
            }

            this.onMouseLeave();
        },

        switchToPauseStatus: function () {
            log(ID + '::switchToPauseStatus');
            this.$playerWrapper.removeClass('playing');
            this.activeVideo.$html.removeClass('playing');
        },

        onPause: function () {
            log(ID + '::onPause');
            this.switchToPauseStatus();
            this.onStopStats();

            // browsers do not allow unmuting, so for users that have unmuted before we'll assume here they want to unmute
            if (this.activeVideo && !this.isMuted && this.isAutoStart) {
                this.player.setMute(false);
            }
        },

        onAdPause: function () {
            log(ID + '::onAdPause');
            this.switchToPauseStatus();
            this.onStopStats();
        },

        onAdRequest: function (e) {
            log(ID + '::onAdRequest', e);
            this.stats.ad.requestCount++;
            this.onGoogleAnalyticsEvent('Ad', 'Requests', this.stats.ad.requestCount);
        },

        onAdImpression: function (e) {
            log(ID + '::onAdImpression', e);

            // Remove upcoming step from the ad schedule since the ad has been filled
            if (this.currentAdSchedule[0] === true) {
                log(
                    ID +
                        'ID}::onCheckAdSchedule - ad slot has been filled, so remove next step from currentAdSchedule'
                );
                this.currentAdSchedule.shift();
            }
            this.forceNextAd = false;

            this.stats.ad.count++;
            this.onGoogleAnalyticsEvent('Ad', 'Impressions', this.stats.ad.count);
        },

        onPlayButtonClicked: function (e) {
            log(ID + '::onPlayButtonClicked');
            if (e && e.stopPropagation) e.stopPropagation();

            if (this.$playButton.is('.playing *')) {
                this.player.pause();
            } else {
                this.player.play();
            }
        },

        onStartStat: function (stat) {
            this.onStopStats();
            log(ID + '::onStartStat', stat.id);
            stat.isActive = true;
            stat.lastTick = Date.now();
        },

        onStopStats: function () {
            log(ID + '::onStopStats');
            this.onCalculateStats();
            this.stats.video.isActive = false;
            this.stats.ad.isActive = false;
            this.stats.buffer.isActive = false;
        },

        onCalculateStats: function () {
            var currentTime = Date.now();
            var stats = [this.stats.ad, this.stats.video, this.stats.buffer];

            var len = stats.length;
            while (len--) {
                var stat = stats[len];
                if (!stat.isActive) continue;

                var diff = currentTime - stat.lastTick;
                stat.duration += diff;
                stat.lastTick = currentTime;

                var steps = stat.pushSteps,
                    stepLen = steps.length,
                    stepDiff = stat.duration - stat.lastPush;

                while (stepLen--) {
                    var durationtThreshold = steps[stepLen][0] * 1000,
                        pushThreshold = steps[stepLen][1] * 1000;

                    if (
                        stat.lastPush >= durationtThreshold ||
                        (stat.lastPush === 0 && stat.duration >= durationtThreshold)
                    ) {
                        if (stepDiff >= pushThreshold) {
                            var durationInSeconds = Math.floor(stat.duration / 1000);
                            this.onGoogleAnalyticsEvent(
                                'Duration',
                                stat.id.charAt(0).toUpperCase() + stat.id.slice(1),
                                durationInSeconds
                            );
                            stat.lastPush = stat.duration;
                        }
                        break;
                    }
                }
                log(ID + '::onCalculateStats', this.stats);
            }
        },

        onGoogleAnalyticsEvent: function (action, label, value) {
            if (typeof ga === 'function') {
                log(ID + '::onGoogleAnalyticsEvent', action, label, value);
                ga('ua.send', {
                    hitType: 'event',
                    eventCategory: 'JW Player Video',
                    eventAction: action,
                    eventLabel: label,
                    eventValue: value,
                });
            }

            if (typeof gtag === 'function') {
                action = action.replaceAll(' ', '_').toLowerCase();
                log(ID + '::onGoogleAnalyticsEvent', action, label, value);
                gtag('event', action, {
                    event_category: 'JW Player Video',
                    event_label: label,
                    value: value,
                });
            }
        },
    };

    /*
     *      Overall creator and eventhandler
     */
    var init = function () {
            log(ID + ' :: loaded');
            findJWplayers();
            initEventHandlers();
        },
        findJWplayers = function ($parent) {
            var selector = '.' + ID + ':not( .initialized )',
                $domItems = $parent == null ? $(selector) : $parent.find(selector),
                len = $domItems.length;

            while (len--) {
                elements.push(new JWplayer($domItems.eq(len)));
            }
        },
        initEventHandlers = function () {
            // FIXME: Implement EventHandler once working on the refresh logic
            // EventHandler.bind( 'refresh', findJWplayers );
        };

    $(init);
})();
